import { encryptValue } from "../util/gameUtils";

let Global = {
  sessionId: null,
  gameTry: 0,
  delta: 0,
  shootCnt: 0,
  xPadd: 0,
  goBackTo: null,
  introShown: false,
  introActive: false,
  totalGoals: 0,
  timeTaken: 0,
  soundEnabled: true,
  limitReached: false,
  userKey: null,
  encryptedScore: null, // Stores encrypted total score
  encryptedMeta: null, // Stores encrypted metadata (t1, t2)
  gameStartTime: 0, // Timestamp of game start
  totalGameTime: 0, // Total game time in seconds
  totalScore: 0, // Decrypted score for quick access
  key1: "",
  key2: "",
  assets: {
    cubemap: {},
    glbs: {
      stadium: {
        key: "stadium",
        path: ["./models/stadium-v1.glb"],
        asset: null,
      },
      collider_left_jump: {
        key: "collider_left_jump",
        path: ["./models/collider_left_jump.glb"],
        asset: null,
      },
      collider_right_jump: {
        key: "collider_right_jump",
        path: ["./models/collider_right_jump.glb"],
        asset: null,
      },
      shooter: {
        key: "shooter",
        path: ["./models/shooter.glb"],
        asset: null,
      },
      defender1: {
        key: "defender1",
        path: ["./models/defender.glb"],
        asset: null,
      },
      defender2: {
        key: "defender2",
        path: ["./models/defender.glb"],
        asset: null,
      },
      defender3: {
        key: "defender3",
        path: ["./models/defender.glb"],
        asset: null,
      },
      keeper: {
        key: "keeper",
        path: ["./models/keeper.glb"],
        asset: null,
      },
      block: {
        key: "block",
        path: ["./models/block.glb"],
        asset: null,
      },
      ball: {
        key: "ball",
        path: ["./models/ball.glb"],
        asset: null,
      },
    },
    textures: {
      shadow: {
        key: "shadow",
        path: ["./textures/shadow.png"],
        asset: null,
      },
      trail: {
        key: "trail",
        path: ["./textures/trail.png"],
        asset: null,
      },
    },
    sounds: {
      catch: {
        key: "catch",
        path: ["./sounds/catch.mp3"],
        asset: null,
      },
      crowd: {
        key: "crowd",
        path: ["./sounds/crowd.mp3"],
        asset: null,
      },
      goal: {
        key: "goal",
        path: ["./sounds/goal.mp3"],
        asset: null,
      },
      kick: {
        key: "kick",
        path: ["./sounds/kick.mp3"],
        asset: null,
      },
      miss: {
        key: "miss",
        path: ["./sounds/miss.mp3"],
        asset: null,
      },
      music: {
        key: "music",
        path: ["./sounds/music.mp3"],
        asset: null,
      },
    },
  },
};
export { Global };
